import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Grade {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-grade',
  templateUrl: './grade.component.html',
  styleUrls: ['./grade.component.css'],
  providers: [HelperService] 
})

export class GradeComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  @ViewChild(DataTableDirective)

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  grades: Grade[] = [];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;
  icon=this.helper.add_icon;
  icon_action='addClick';
  allgrade:any=[];
  selectedgrade;
  syllabus_id=0;
  red='';
  grade_id=0;
  grade_name='';
  syllabusname;
  user_permissions:any=[];
  user=this.cookie.get('user_id');
  datas;
  teacherroles;
  user_roleid;checkIfTeacher;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) {
    this.activatedRouter.params.subscribe((params: Params) => {
      this.syllabus_id = params['syid'];
      
    });
  }

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
    this.http.get(this.helper.base_url+'http/get/checkusers',{ headers: this.headers })
    
    .subscribe(data => {
      let body = JSON.parse(data['_body']);
      // this.datas = JSON.parse(data['_body']).users[0];
      // this.user_roleid = JSON.parse(data['_body']).users[0]['role_id'];
      // //console.log(this.datas);
      // this.teacherroles = JSON.parse(data['_body']).teacherroles;
      // console.log(this.teacherroles);
      // console.log(this.user_roleid);
      //console.log(this.teacherroles.includes(this.user_roleid));
      //this.checkIfTeacher = this.teacherroles.includes(this.user_roleid);
      this.checkIfTeacher = body.success;
      if(this.checkIfTeacher == false)
      {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/grade/'+this.syllabus_id,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(grades => {
        this.grades = grades;
        //console.log(grades);
          this.dtTrigger.next();
        
       
      });
    }
    else{
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10
      };
      
      this.http.get(this.helper.base_url+'http/get/grade/'+this.syllabus_id+'?teacher_id=1',{ headers: this.headers })
        .map(this.extractData)
        .subscribe(grades => {
          this.grades = grades;
          //console.log(grades);
            this.dtTrigger.next();
          
         
        });
    }
  });
      this.http.get(this.helper.base_url+'http/get/syllabus/'+this.syllabus_id,{ headers: this.headers })
      .subscribe(
         
        (data) => {
          let body = JSON.parse(data['_body']);
          //console.log(body);
          this.syllabusname = body.data[0].name;
          //console.log(this.syllabusname);
          //alert(this.syllabusname);
          // this.refresh();
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );
  }
  

  
  addClick(e){
    this.http.get(this.helper.base_url+'http/get/grades/'+this.syllabus_id,{ headers: this.headers })
      .subscribe(
         
          (data) => {
            this.selectedgrade=JSON.parse(data.text())['data'][1]
            this.allgrade=JSON.parse(data.text())['data'][0];
            
            // this.refresh();
          }, //For Success Response
          err => {console.error(err)} //For Error Response
      );
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  delete_gradeClick(id){
 
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
      //this.snackbar.open('Are you sure!', 'Delete', {
        duration: 3000,
        extraClasses:  ['warning-snackbar'],
      });
      snackBarRef.onAction().subscribe(() => {
        this.http.get(this.helper.base_url+'http/delete/syllabus_grade/'+id+'/'+this.syllabus_id,{ headers: this.headers })
      .subscribe(
         
          (data) => {
            let body = JSON.parse(data['_body']);
            //console.log(body)
            if(body.success == 1)
            {
              this.listClick(null) ;
              this.refresh(false,body.message) ;
            }
            else
            {
              this.snackbar.open(body.message, null, {
                duration:5000,
                  extraClasses:'error-snackbar',
                  verticalPosition:'top'
                });
            }
          },
          //this.refresh(false,"Grade deleted from syllabus"), //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
      });  
  }
  editClick(id,name){
    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.grade_name=name;
    this.grade_id=id;
  }
  update_form(updateForm: NgForm){
    let id =this.grade_id;
  
   let body = new FormData();
   
   body.append('name', updateForm.value.name);
   body.append('syllabus_id', updateForm.value.syllabus_id);
  
    this.http.post(this.helper.base_url+'http/update/syllabus_grade/'+id, body,{ headers: this.headers })
    .subscribe(
      (res) => {
        let body = JSON.parse(res['_body']);
        //console.log(body)
         if(body.success == 1)
         {
          this.listClick(null) ;
          this.refresh(false,body.message) ;
         }
         else
         {
          this.snackbar.open(body.message, null, {
            duration:5000,
              extraClasses:'error-snackbar',
              verticalPosition:'top'
            });
         }
      }, //For Success Response
       err => {console.error(err)} //For Error Response);
    );
  }

 refresh(val=false,msg=''){
   
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["grade/"+this.syllabus_id]));
      
 }
 addGrade(addForm: NgForm){
  let body = new FormData();
  //alert(addForm.value.name);
  //body.append('grades[]', this.selectedgrade);
  

   if(addForm.value.name){
    body.append('grades', addForm.value.name);
      this.http.post(this.helper.base_url+'http/add/syllabus_grade/'+this.syllabus_id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
      let body = JSON.parse(res['_body']);
      //console.log(body)
       if(body.success == 1)
       {
        this.listClick(null) ;
        this.refresh(false,"Grade Added Successfully") ;
       }
       else
       {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
       }
     
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );

   }else{
     //this.red='red';
     this.snackbar.open('Provide Grade Name', null, {
      duration:5000,
        extraClasses:'error-snackbar',
        verticalPosition:'top'
      });
   }
   
  
 }
 gradeonchage(status,id){
   if(status){
this.selectedgrade.push(id);
   }else{
     let index = this.selectedgrade.indexOf(id);
 
    if (index > -1) {
       this.selectedgrade.splice(index, 1);
    }
   }
  
 }


  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }
   backbtn(){
   
    window.history.back();
  }
  add_form(addForm: NgForm){
    let body = new FormData();
    body.append('name', addForm.value.name);
  
     this.http.post(this.helper.base_url+'http/add/grades', body,{ headers: this.headers })
     .subscribe(
       (res) => {
        this.listClick(null) ;
        this.refresh(false,'Grade added successfully') ;
       }, //For Success Response
        err => {console.error(err)} //For Error Response);
     );
   }
   publish_gradeClick(id,gradeid){
      this.http.get(this.helper.base_url+'http/publish/syllabus_grade/'+id+'/'+this.syllabus_id+'/'+gradeid,{ headers: this.headers })
    .subscribe(
       
        (data) => {
          let body = JSON.parse(data['_body']);
          //console.log(body)
          if(body.success == 1)
          {
            this.listClick(null) ;
            this.refresh(false,body.message) ;
          }
          else
          {
            this.snackbar.open(body.message, null, {
              duration:5000,
                extraClasses:'error-snackbar',
                verticalPosition:'top'
              });
          }
        },
        //this.refresh(false,"Grade deleted from syllabus"), //For Success Response
        err => {console.error(err)} //For Error Response
    );  
}

}



// WEBPACK FOOTER //
// ./src/app/grade/grade.component.ts